export default function removeEmptyFields(data: any) {
  Object.entries(data || "").forEach(([key, value]: any) => {
    if (typeof value === "object") removeEmptyFields(value);
    if (
      value === "" ||
      value === undefined ||
      Number.isNaN(value) ||
      value === null
    ) {
      delete data[key];
    }
  });
  return data;
}
